import React, { useState, useEffect, useRef, Fragment, useCallback, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getQueryStr } from '../../../../../../../../common/utils/browserUtils';
import { getAllUrlParams } from '../../../../../../../helpers/utils';
import { getMMT_HLD_OBJ } from '../../../../../../../../common/utils/appUtils';
import OmnitureUtils from '../../../../../../../../common/utils/Omniture/OmnitureUtils';
import { faOnDropdownClick, faOnDropdownValueSelect } from '../analytics-services';
import './styles.scss';

const SortDropDown = ({ listingSorters, seoFilters }) => {
  const [isdropDownVisible, setDropDownVisisble] = useState(false);
  const sortingSectionRef = useRef(null);
  const search = useSearchParams();
  const navigate = useNavigate();
  const { fromSEO } = getMMT_HLD_OBJ();

  const handleDropDown = () => {
    if (!isdropDownVisible) {
      OmnitureUtils.trackClickEvent({ prop54: 'filter_click_sort' });
      faOnDropdownClick();
    }
    setDropDownVisisble(!isdropDownVisible);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleClickOutside = event => {
    if (sortingSectionRef.current && !sortingSectionRef.current.contains(event.target)) {
      setDropDownVisisble(false);
    }
  };

  const handleSortApply = useCallback(
    (sorter, sorterValue) => {
      let urlParams = getAllUrlParams(search);
      setDropDownVisisble(false);
      urlParams = {
        ...urlParams,
        ...seoFilters,
        version: 3,
      };

      listingSorters?.forEach(listingSorter => {
        if (urlParams[listingSorter?.urlParam]) {
          urlParams[listingSorter?.urlParam] = null;
        }
      });

      urlParams[sorter.urlParam] = sorterValue?.uniqueId;

      const queryString = getQueryStr(urlParams);
      faOnDropdownValueSelect({
        sorterName: sorter?.name,
        sorterValue: getSortOrderText(sorterValue?.sorterText) ?? '',
      });
      OmnitureUtils.trackClickEvent({
        prop54: `filter_apply_ui_Sortby_${sorterValue?.uniqueId}`,
      });
      if (fromSEO) {
        navigate(`?${queryString}`);
      } else {
        navigate(`/holidays/india/search?${queryString}`);
      }
    },
    [search, listingSorters, seoFilters]
  );

  const getSortOrderText = useCallback(text => {
    if (text === 'Low') {
      return 'Low to High';
    }
    if (text === 'High') {
      return 'High to Low';
    }

    return '';
  }, []);

  const appliedSortValue = useMemo(() => {
    const urlParams = getAllUrlParams(search);
    let appliedSorter = listingSorters?.[0];
    let appliedSorterValue = listingSorters?.[0]?.listingSorterValues?.[0];
    for (let i = 0; i < listingSorters?.length; i++) {
      const listingSorter = listingSorters[i];
      const appliedValue = urlParams[listingSorter.urlParam];
      if (appliedValue) {
        for (let j = 0; j < listingSorter?.listingSorterValues?.length; j++) {
          const listingFilterValue = listingSorter.listingSorterValues[j];
          if (appliedValue === listingFilterValue?.uniqueId) {
            appliedSorter = listingSorter;
            appliedSorterValue = listingFilterValue;
          }
        }
      }
    }

    const sorterText = getSortOrderText(appliedSorterValue?.sorterText);

    return `${appliedSorter?.name}${sorterText ? ' - ' : ''}${sorterText}`;
  }, [search, listingSorters, getSortOrderText]);

  return (
    <div className="sortingSection" ref={sortingSectionRef}>
      <div className="sortingValueSection" onClick={handleDropDown}>
        <span className="title">Sorted By: </span>
        <span className="value">{appliedSortValue}</span>
        <span className="icon mmt-chevron-down" />
      </div>
      {isdropDownVisible && (
        <ul className="sortingDropdown">
          {listingSorters?.map(sorter => (
            <Fragment key={sorter?.id}>
              {sorter?.listingSorterValues?.map(sorterValue => {
                const sorterText = getSortOrderText(sorterValue?.sorterText);
                return (
                  <li
                    key={`${sorter?.id}_${sorterValue?.uniqueId}`}
                    onClick={() => handleSortApply(sorter, sorterValue)}
                  >
                    {sorter?.name}
                    {sorterText ? ' - ' : ''}
                    {sorterText}
                  </li>
                );
              })}
            </Fragment>
          ))}
        </ul>
      )}
    </div>
  );
};
export default SortDropDown;
